import { Link } from "react-router-dom";
import Shell from "@/components/app/Shell";
import VideoEmbed from "@/components/app/VideoEmbed";
import { useOverride } from "@/context/ContentContext";
import { BREATHE_FRAMEWORK } from "@/data/breatheFramework";
import { Wind, ArrowLeft } from "lucide-react";

function FrameworkCard({ item, index }) {
  const videoUrl = useOverride("breathe_framework", item.key, "video_url", "");
  const oTitle = useOverride("breathe_framework", item.key, "title", item.title);
  const oBody = useOverride("breathe_framework", item.key, "body", item.body);
  return (
    <div
      className="bg-warm-white border border-edge rounded-3xl p-6 md:p-8"
      data-testid={`breathe-detail-${item.key}`}
    >
      <div className="flex items-start gap-4">
        <div
          className="flex-shrink-0 w-14 h-14 rounded-2xl bg-navy text-gold font-display font-bold text-2xl flex items-center justify-center"
          data-testid={`breathe-detail-letter-${item.key}`}
        >
          {item.letter}
        </div>
        <div className="min-w-0">
          <div className="text-xs uppercase tracking-widest text-mauve font-semibold">
            Step {index + 1} of {BREATHE_FRAMEWORK.length}
          </div>
          <h2 className="font-display text-xl md:text-2xl font-bold text-navy mt-1">
            {item.letter} — {oTitle}
          </h2>
        </div>
      </div>

      <div className="mt-6" data-testid={`breathe-detail-video-${item.key}`}>
        <VideoEmbed
          value={videoUrl}
          title={`${item.letter} — ${oTitle}`}
          placeholder={`${item.letter} — ${oTitle} · video coming soon`}
          testid={`breathe-detail-video-${item.key}`}
        />
      </div>

      <p
        className="mt-6 text-ink-dark leading-relaxed"
        data-testid={`breathe-detail-body-${item.key}`}
      >
        {oBody}
      </p>
    </div>
  );
}

export default function BreatheFramework() {
  return (
    <Shell>
      <div className="mb-6">
        <Link
          to="/learn"
          data-testid="breathe-detail-back"
          className="inline-flex items-center gap-2 text-sm text-ink-mid hover:text-navy"
        >
          <ArrowLeft size={14} /> Back to Learn
        </Link>
      </div>

      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-mauve font-semibold flex items-center gap-2">
          <Wind size={12} /> Foundational
        </div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-navy mt-1">
          The BREATHE Framework in Detail
        </h1>
        <p className="text-ink-mid mt-3 max-w-2xl leading-relaxed">
          Seven pieces that work together. If progress ever feels stuck, one of these usually needs
          more attention — come back to this page anytime.
        </p>
      </div>

      <div className="space-y-6">
        {BREATHE_FRAMEWORK.map((item, i) => (
          <FrameworkCard key={item.key} item={item} index={i} />
        ))}
      </div>
    </Shell>
  );
}
